<template>
  <div :class="classes">
    <pt-page-title title="扫码缴费记录" :isSearch="true" @search="search" @emptySearch="emptySearch" :keyword="keyword"></pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="filter">
      <el-button type="primary" @click="filter()">筛选</el-button>
      <el-button type="primary" @click="exportOldToNewAudit()" :loading="exportLoading">导出</el-button>
      <!-- <el-button type="primary" @click="exportOldToNewAudit(true)" v-if="hasAllExport" :loading="exportLoading">导出全部记录</el-button> -->
      <el-button type="primary" @click="exportHistoryOldToNewAudit">导出历史</el-button>
      <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
    </pt-page-factor-filter>
    <pt-scan-payment-table ref="table" :paramsData="paramsData">
    </pt-scan-payment-table>
  </div>
</template>

<script>
// 组件class前缀
import { filterLabels } from './scan-payment'
import ptScanPaymentTable from './pt-scan-payment-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-scan-payment'
// 权限
export default {
  name: 'pt-scan-payment',
  components: {
    ptScanPaymentTable
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableData () {
      return this.$refs.table.tableData
    }
  },
  props: {
    areaList: {
      type: Array,
      default: function () {
        return []
      }
    },
    companyList: {
      type: Array,
      default: function () {
        return []
      }
    },
    exportLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filterLabels: filterLabels,
      params: {},
      paramsData: {},
      keyword: ''
    }
  },
  watch: {
    areaList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'addressCode') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    },
    companyList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'subMerchantOrganizationId') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    search (val) {
      this.keyword = val
      emptyObject(this.paramsData)
      this.$set(this.paramsData, 'keyword', val)
    },
    emptySearch (val) {
      this.$delete(this.paramsData, 'keyword')
    },
    filter () {
      let params = { ...this.params }
      for (var key in params) {
        if (key === 'modifiedDate') {
          params = { ...params, ...params.modifiedDate }
          this.$delete(params, 'modifiedDate')
          this.$delete(params, 'index')
        }
      }
      this.paramsData = { ...params }
      for (var key2 in this.paramsData) {
        if (!this.paramsData[key2]) {
          this.$delete(this.paramsData, key2)
        }
      }
    },
    // 导出
    exportOldToNewAudit () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          let params = { ...this.params }
          for (var key in params) {
            if (key === 'modifiedDate') {
              params = { ...params, ...params.modifiedDate }
              this.$delete(params, 'modifiedDate')
              this.$delete(params, 'index')
            }
          }
          for (var key2 in params) {
            if (!params[key2]) {
              this.$delete(params, key2)
            }
          }
          this.$emit('scanPaymentExport', params)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    // 导出历史
    exportHistoryOldToNewAudit () {
      this.$router.push('/export-history/pay_order_export?name=pay_order_export')
    },
    cleanParams () {
      this.params = {}
      emptyObject(this.params)
      this.filter()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
